import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';
import { Label } from './ui/label';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { X, Search } from 'lucide-react';

const FilterBar = ({ filters, setFilters, searchValue = '', onSearchChange = null }) => {
  const resetFilters = () => {
    setFilters({
      category: 'All',
      priority: 'All',
      status: 'All',
      workAssignment: 'All',
    });
    if (onSearchChange) onSearchChange('');
  };

  return (
    <div className="bg-white border-b border-slate-200" data-testid="filter-bar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-wrap items-end gap-4">
          {onSearchChange && (
            <div className="flex-1 min-w-[200px]">
              <Label className="text-xs font-medium text-slate-600 mb-1.5 block">Search</Label>
              <div className="relative">
                <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-slate-400" />
                <Input
                  value={searchValue}
                  onChange={(e) => onSearchChange(e.target.value)}
                  placeholder="Search tasks..."
                  className="pl-8 h-10"
                  data-testid="task-search-input"
                />
              </div>
            </div>
          )}
          <div className="flex-1 min-w-[200px]">
            <Label className="text-xs font-medium text-slate-600 mb-1.5 block">Category</Label>
            <Select value={filters.category} onValueChange={(value) => setFilters({ ...filters, category: value })}>
              <SelectTrigger data-testid="filter-category">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="All">All Categories</SelectItem>
                <SelectItem value="Truck Section">Truck Section</SelectItem>
                <SelectItem value="Machinery Section">Machinery Section</SelectItem>
                <SelectItem value="General">General</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="flex-1 min-w-[200px]">
            <Label className="text-xs font-medium text-slate-600 mb-1.5 block">Priority</Label>
            <Select value={filters.priority} onValueChange={(value) => setFilters({ ...filters, priority: value })}>
              <SelectTrigger data-testid="filter-priority">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="All">All Priorities</SelectItem>
                <SelectItem value="Critical">Critical</SelectItem>
                <SelectItem value="High">High</SelectItem>
                <SelectItem value="Medium">Medium</SelectItem>
                <SelectItem value="Low">Low</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="flex-1 min-w-[200px]">
            <Label className="text-xs font-medium text-slate-600 mb-1.5 block">Status</Label>
            <Select value={filters.status} onValueChange={(value) => setFilters({ ...filters, status: value })}>
              <SelectTrigger data-testid="filter-status">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="All">All Statuses</SelectItem>
                <SelectItem value="pending">Pending</SelectItem>
                <SelectItem value="in-progress">In Progress</SelectItem>
                <SelectItem value="completed">Completed</SelectItem>
                <SelectItem value="blocked">Blocked</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="flex-1 min-w-[200px]">
            <Label className="text-xs font-medium text-slate-600 mb-1.5 block">Work Assignment</Label>
            <Select value={filters.workAssignment} onValueChange={(value) => setFilters({ ...filters, workAssignment: value })}>
              <SelectTrigger data-testid="filter-work-assignment">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="All">All Assignments</SelectItem>
                <SelectItem value="Site">Site</SelectItem>
                <SelectItem value="Head Office">Head Office</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <Button
            onClick={resetFilters}
            variant="outline"
            data-testid="reset-filters-button"
            className="h-10"
          >
            <X className="h-4 w-4 mr-2" />
            Reset
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FilterBar;
